module.exports = __webpack_public_path__ + "assets/avatar-wobbles.438d4a97.svg";